var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHabits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7049 18.7645C18.8868 21.9135 14.8604 22.9923 11.7114 21.1743C9.49325 19.8936 8.30082 17.5083 8.42608 15.1079",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29541 11.2356C11.1135 8.0866 15.1399 7.00772 18.2889 8.8258C20.3979 10.0434 21.5817 12.259 21.581 14.5276",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04677 16.3032C5.83966 16.6619 5.96257 17.1206 6.32129 17.3277C6.68001 17.5348 7.1387 17.4119 7.34581 17.0532L6.04677 16.3032ZM8.11968 14.2128L8.49468 13.5633C8.13596 13.3562 7.67726 13.4791 7.47016 13.8378L8.11968 14.2128ZM10.0355 16.185C10.3942 16.3921 10.8529 16.2692 11.06 15.9105C11.2671 15.5517 11.1442 15.093 10.7855 14.8859L10.0355 16.185ZM7.34581 17.0532L8.7692 14.5878L7.47016 13.8378L6.04677 16.3032L7.34581 17.0532ZM7.74468 14.8624L10.0355 16.185L10.7855 14.8859L8.49468 13.5633L7.74468 14.8624Z",
    fill: "#29C88B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9414 13.1165C24.1485 12.7578 24.0256 12.2991 23.6669 12.092C23.3081 11.8849 22.8495 12.0078 22.6423 12.3665L23.9414 13.1165ZM21.8685 15.2069L21.4935 15.8564C21.8522 16.0635 22.3109 15.9406 22.518 15.5819L21.8685 15.2069ZM19.9526 13.2348C19.5939 13.0277 19.1352 13.1506 18.9281 13.5093C18.721 13.868 18.8439 14.3267 19.2026 14.5338L19.9526 13.2348ZM22.6423 12.3665L21.219 14.8319L22.518 15.5819L23.9414 13.1165L22.6423 12.3665ZM22.2435 14.5574L19.9526 13.2348L19.2026 14.5338L21.4935 15.8564L22.2435 14.5574Z",
    fill: "#29C88B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabits);
export default __webpack_public_path__ + "static/media/Habits.704c362b68111066cc7abca44657749d.svg";
export { ForwardRef as ReactComponent };